import { render, staticRenderFns } from "./VaProgressCircle.demo.vue?vue&type=template&id=3fe7735d&"
import script from "./VaProgressCircle.demo.vue?vue&type=script&lang=js&"
export * from "./VaProgressCircle.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports